module.exports = __webpack_public_path__ + "img/default-photo.abe79393.svg";